"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/FMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_76)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_76`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9648 2.65967L12.6736 4.84914H14.9824L13.1157 6.20353L13.8315 8.393L11.9648 7.03862L10.0981 8.393L10.8139 6.20353L8.94726 4.84914H11.256L11.9648 2.65967ZM2.64551 11.979L4.83498 11.2632V8.96142L6.18937 10.8281L8.37884 10.1123L7.02446 11.979L8.37884 13.8386L6.18937 13.1298L4.83498 14.9895V12.6877L2.64551 11.979ZM11.9648 21.2983L11.256 19.1088H8.94726L10.8139 17.7544L10.0981 15.5579L11.9648 16.9123L13.8315 15.5579L13.1157 17.7544L14.9824 19.1088H12.6736L11.9648 21.2983ZM21.2841 11.979L19.0946 12.6877V14.9895L17.7402 13.1298L15.5508 13.8386L16.9052 11.979L15.5508 10.1123L17.7402 10.8281L19.0946 8.96142V11.2632L21.2841 11.979Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_76`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as FMFlag };
